export const newArticleType = (state = [], action) => {
    switch (action.type) {
        case 'ADD_ARTICLETYPE_INPUTS':
            return [
                {
                    ...state[0],
                    sizeCat: action.sizeCat,
                    name: action.name,
                    gender: action.gender,
                    articleNumber: action.articleNumber,
                    price: action.price,
                    style: action.style,
                    isValid: action.isValid
                }
            ]
        case 'ADD_ARTICLETYPE_IMAGE': 
            return [
                {
                    ...state[0],
                    image: action.image
                }
            ]
        default:
            return state
    }
}

export const updatedArticleType = (state = [], action) => {
    switch (action.type) {
        case 'UPDATE_ARTICLETYPE_INPUTS':
            return [
                {
                    ...state[0],
                    sizeCat: action.sizeCat,
                    name: action.name,
                    gender: action.gender,
                    articleNumber: action.articleNumber,
                    price: action.price,
                    style: action.style,
                    isValid: action.isValid
                }
            ]
        default:
            return state
    }
}